import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface UpdateEmsInput {
    emsId: string;
}

const updateEms = async (data: UpdateEmsInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/ems/update`,
        data,
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
};

export const useUpdateEms = () => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (data: UpdateEmsInput) => updateEms(data, sessionContext?.sessionId ?? null)
    });
}; 